<template>
    <label >
        <input type="radio" class="cb" :name="name" :value="value" :id="cId" :checked="checked" @click="select">
        <label :for="cId" class="icon-cb">
        </label>
    </label>
</template>
<script>
    export default {
        props:{
            value: {}, 
            cId:{
                type:String
            },
            name:String,
            bindTo:{}
        },
        computed:{
            checked(){
                if(!this.value || !this.bindTo){
                    return false;
                }
                if(typeof this.value === 'object'){
                    return this.value[this.name] === this.bindTo[this.name]
                }else{
                    return this.value === this.bindTo
                }
            }
        },
        data(){
            return {
                selected:{}
            }
        },
        methods:{
            select(){
                this.$emit('input', this.value)
            }
        },
        watch:{
            value(val){
                this.selected = val
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Radio.vue?609dd7de